import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import Modal from 'react-modal';

import './styles.css';

const Toast = ({ isOpen, onRequestClose, hasErrors }) => {
  const afterModalOpen = () => {
    setTimeout(() => {
      onRequestClose();
    }, 5000);
  };
  return (
    <Modal
      isOpen={isOpen}
      onAfterOpen={afterModalOpen}
      onRequestClose={onRequestClose}
      ariaHideApp={false}
      closeTimeoutMS={1000}
      shouldCloseOnOverlayClick={false}
      className={cx({ 'modal-container': !hasErrors, 'modal-container error': hasErrors })}
      overlayClassName="modal-overlay"
    >
      <i
        className={
          cx({ 'fas fa-check-circle modal-icon': !hasErrors, 'fal fa-times-circle modal-icon has-error': hasErrors })
        }
      />
      <div className="modal-body">
        <h3>{`Email Preferences${hasErrors ? ' not ' : ' '}Updated`}</h3>
        <p>{hasErrors ? 'Ops! Something went wrong...' : 'Your notifications change has been successfully saved.'}</p>
      </div>
      <i
        className="far fa-times"
        onClick={onRequestClose}
        role="button"
        aria-label="Close"
        tabIndex="0"
        onKeyDown={onRequestClose}
      />
    </Modal>
  );
};

Toast.propTypes = {
  isOpen: PropTypes.bool,
  onRequestClose: PropTypes.func,
  hasErrors: PropTypes.bool,
};

Toast.defaultProps = {
  isOpen: false,
  onRequestClose: () => null,
  hasErrors: false,
};

export default Toast;
